import img1 from '../../assets/caseStudy/projectmanegement.jpeg';
import img2 from '../../assets/caseStudy/industrailwaste.jpeg';
import img3 from '../../assets/caseStudy/tpandfrieght.jpeg';
import img4 from '../../assets/caseStudy/oilandgas.jpg';
import img5 from '../../assets/caseStudy/constructionM.jpeg';
import img6 from '../../assets/caseStudy/IndustrialWarehousing.jpg';
import blocks from '../../assets/caseStudy/blocks.jpg';

const fakeData = [
  {
    id: 1,
    designation: "Project management",
    title: "Architecture and engineering",
    img: img1,
    category: "Construction",
  },
  {
    id: 2,
    designation: "Waste collection",
    title: "Recycling services",
    img: img2,
    category: "Waste Management",
  },
  {
    id: 3,
    designation: "Freight forwarding",
    title: "Logistics Services - Supply Chain Management",
    img: img3,
    category: "Logistics Services",
  },
  {
    id: 4,
    designation:
      "Transportation and storage solutions for crude oil and natural gas",
    title: "Refining and marketing services for finished petroleum products",
    img: img4,
    category: "Oil and Gas",
  },
  {
    id: 5,
    designation: "Building construction and renovation",
    title: "Turnkey solutions for all phases of a project",
    img: img5,
    category: "Construction",
  },
  {
    id: 6,
    designation: "Supply chain management",
    title: "Distribution and warehousing services",
    img: img6,
    category: "Logistics Services",
  },
  {
    id: 7,
    designation: "Building Construction",
    title: "Architecture and engineering",
    img: blocks,
    category: "Construction",
  },
];
export default fakeData;